import { useState } from "react";
import OTPVerify from "./OTPVerify";
import Button from "heroic-ui-library/dist/components/Button";
import Loading from "react-loading";
import toast from "react-hot-toast";
import { apiClient } from "../../api/api-client";
import PINField from "./PINField";
import RoundButton, {
  BtnType,
} from "heroic-ui-library/dist/components/RoundButton";

type Props = {
  phoneNumber: string;
  countryCode: string;

  onSuccess: () => void;
  onClose: () => void;
  setPhoneNumber: (value: string) => void;
  setCountryCode: (value: string) => void;
};

export default function ForgotPassword({
  countryCode,
  phoneNumber,
  onClose,
  onSuccess,
  setCountryCode,
  setPhoneNumber,
}: Props) {
  const [pinCode, setPinCode] = useState("");
  const [confirmPin, setConfirmPinCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [path, sePath] = useState<"otpVerification" | "createPIN">(
    "otpVerification"
  );

  const createPin = async () => {
    if (pinCode != confirmPin) {
      return toast.error("Pin does not match");
    }

    setIsLoading(true);
    const responseCreateParent = await apiClient.createParentAccount(
      countryCode + phoneNumber.replace(/\D/g, "")
    );

    const response = await apiClient.setParentPIN(
      pinCode,
      responseCreateParent.parent_code
    );
    setIsLoading(false);

    if (response.state != 200) {
      return toast.error(response.error);
    }

    onSuccess();
  };

  return (
    <div className="mt-4">
      <RoundButton
        size="small"
        btnType={BtnType.close}
        className=" !absolute !-top-8 !-right-8"
        onClick={onClose}
      />
      <h1 className="top-heading text-center mb-3">Reset Password</h1>
      <div className="flex justify-center items-center mb-4">
        <div className="border-t-2 border-dotted border-gray-400 flex-1" />
        <div className="border-t-2 border-dotted border-gray-400 flex-1" />
      </div>
      {path == "otpVerification" && (
        <>
          <OTPVerify
            phoneNumber={phoneNumber}
            countryCode={countryCode}
            setPhoneNumber={setPhoneNumber}
            setCountryCode={setCountryCode}
            onVerificationSuccess={() => sePath("createPIN")}
          />
        </>
      )}
      {path == "createPIN" && (
        <>
          <div className="text-2xl font-acme">Enter your new PIN</div>
          <>
            <PINField
              pinCode={pinCode}
              setPinCode={setPinCode}
              className="text-lg w-full mb-2"
            />
            <PINField
              className="text-lg w-full"
              pinCode={confirmPin}
              setPinCode={setConfirmPinCode}
              placeholder="Confirm PIN"
            />

            {!isLoading && (
              <Button
                onClick={createPin}
                btnType="green"
                className="submit-btn mt-4"
                label={"Create PIN"}
              />
            )}
            {isLoading && (
              <div className="w-full items-center justify-center flex mt-4">
                <Loading color="#002356" type="spin" />
              </div>
            )}
          </>
        </>
      )}
    </div>
  );
}
